import { HDKey } from '@scure/bip32';
import * as secp from '@noble/secp256k1';
import { GONKA_HD_PATH } from './config.js';
/**
 * Derive the Gonka private key from a BIP39 seed at the locked HD path.
 *
 * The caller owns the returned Uint8Array and is responsible for zeroing
 * it after use (see `./zero.ts`).
 */
export function deriveGonkaPrivateKey(seed) {
    const master = HDKey.fromMasterSeed(seed);
    const child = master.derive(GONKA_HD_PATH);
    if (!child.privateKey) {
        throw new Error('HD derivation produced no private key');
    }
    // Copy to detach from the HDKey's internal buffer so we can zero it.
    return new Uint8Array(child.privateKey);
}
/**
 * Compute the compressed (33-byte) secp256k1 public key from a private key.
 */
export function derivePublicKey(privateKey) {
    if (privateKey.length !== 32) {
        throw new Error(`Private key must be 32 bytes, got ${privateKey.length}`);
    }
    return secp.getPublicKey(privateKey, /* isCompressed */ true);
}
//# sourceMappingURL=hd.js.map